import { SignInCommand } from "../models/sign-in-command";

export class SignIn {
    public static readonly type = "[Auth] SignIn";
    constructor(public payload: SignInCommand) {}
}
